"use client";

import { TCareerDescriptionSection } from "@shared/types";
import { HtmlParser } from "@shared/ui";

export function CareerDescriptionSection({ title, description }: TCareerDescriptionSection) {
  return (
    <section className="bg-white">
      <div className="container relative lg:max-w-[872px] mx-auto">
        <h4 className="font-semibold text-2xl leading-[134%] mb-4">{title}</h4>
        <div className="text-lg text-gray-700">
          <HtmlParser data={description} />
        </div>
      </div>
    </section>
  );
}
